import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import React, { useEffect, useState, useRef } from 'react';
import { Button } from '@ipc/ipc-components';
import { Link } from '@ipc/ipc-core';
import ListTable from '../../../../common/list-table/components/ListTable';
import TableDefinitions from '../../../../common/TableDefinitions';
import {
  getData, getIsLoading, getDataInactive, getIsLoadingInactive, getEditMrdSuccessStatus,
} from '../redux/selectors/DeviceInformationSelectors';
import { DeviceInformationStyle } from '../component/DeviceInformation.styles';
import { getUserRole } from '../../../../common/user/redux/selectors/UserSelectors';
import deviceInformationTableColumns from './DeviceInformationTableColumns';
import EditMrdDialog from '../edit-mrd/component/EditMrdDialog';

function DeviceInformationContainer(props) {
  const {
    isLoading,
    data,
    userRole,
    isLoadingInactive,
    dataInactive,
    tableLoad,
    editMrdSuccessStatus,
  } = props;
  const isUserIpcAdmin = userRole === 'IPC_ADMIN';
  const isUserIpcRole = ['IPC_ADMIN', 'IPC_VIEWER'].includes(userRole);
  const [showInactive, setShowInactive] = useState(false);
  const [showEditForm, setShowEditForm] = useState(false);
  const [selectedRow, setSelectedRow] = useState({});
  const firstRender = useRef(true);

  const onRowEdit = (row) => {
    setShowEditForm(true);
    setSelectedRow(row);
  };

  const hideEditForm = () => {
    setShowEditForm(false);
    setSelectedRow({});
  };

  useEffect(() => {
    if (firstRender.current) {
      firstRender.current = false;
      return;
    }
    tableLoad(showInactive ? TableDefinitions.MRD_INACTIVE.id : TableDefinitions.MRD.id);
  }, [showInactive]);

  useEffect(() => {
    if (editMrdSuccessStatus) {
      hideEditForm();
    }
  }, [editMrdSuccessStatus]);

  const columns = deviceInformationTableColumns(showInactive ? dataInactive : data, userRole, onRowEdit);
  return (
    <DeviceInformationStyle>
      <div className="mrd-button-container">
        {isUserIpcAdmin && (
          <>
            <Button
              onClick={() => { setShowInactive(!showInactive); }}
              className="primary-button-false mrd-button"
            >
              {`Show ${showInactive ? 'active' : 'inactive'}`}
            </Button>
            <Link to={{ pathname: '/add-mrd' }}>
              <Button
                className="primary-button-false mrd-button"
              >
                New
              </Button>
            </Link>
          </>
        )}
      </div>
      <ListTable
        listId={showInactive ? TableDefinitions.MRD_INACTIVE.id : TableDefinitions.MRD.id}
        loading={showInactive ? isLoadingInactive : isLoading}
        columns={columns}
        data={showInactive ? dataInactive : data}
        isDownloadEnable
        downloadFileAs="MRD_DEVICE_INFORMATION"
        downloadFileTemplate={
          isUserIpcRole ? 'MRD_DEVICE_INFORMATION_IPC_ROLE' : 'MRD_DEVICE_INFORMATION_OPER_ROLE'
        }
      />
      {showEditForm && (
        <EditMrdDialog
          closeDialog={hideEditForm}
          openDialog={showEditForm}
          selectedRow={selectedRow}
          activeMrdList={data}
          inactiveMrdList={dataInactive}
        />
      )}
    </DeviceInformationStyle>
  );
}

function mapStateToProps(state) {
  return {
    data: getData(state),
    isLoading: getIsLoading(state),
    userRole: getUserRole(state),
    dataInactive: getDataInactive(state),
    isLoadingInactive: getIsLoadingInactive(state),
    editMrdSuccessStatus: getEditMrdSuccessStatus(state),
  };
}

DeviceInformationContainer.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  isLoading: PropTypes.bool,
  userRole: PropTypes.string,
  tableLoad: PropTypes.func,
  dataInactive: PropTypes.arrayOf(PropTypes.object),
  isLoadingInactive: PropTypes.bool,
  editMrdSuccessStatus: PropTypes.bool,
};

export default connect(mapStateToProps)(DeviceInformationContainer);
